import styled from 'styled-components';
import ListItemNoIcon from './ListItemNoIcon';

const SeperatedListItemNoIcon = styled(ListItemNoIcon)`
  ${({ $standalone, theme }) => `
    border-left: 1px solid ${theme.palette.common.backgroundDark};

    ${theme.breakpoints.down('xs')} {
      min-height: ${$standalone ? 'none' : '42px'};
    }
  `}
`;

export default SeperatedListItemNoIcon;
